export class SubscriptionModel {
  static STATUS_CANCELLED = 'canceled';
  static STATUS_ACTIVE = 'active';

  constructor(
    public id: number,
    public status: string,
    public subscription_interval: string,
    public start_date: number,
    public current_period_start: number,
    public current_period_end: number,
    public provider: number
  ) {
  }
}
